/* One emoji per architecture fixture type — shared by the floor designer,
   the seating view and the buffet planner, so a plant is the same plant on
   every plan a table appears in. */
export const FIXTURE_EMOJI = {
  kitchen: '🍳',
  washroom: '🚻',
  stairs: '🪜',
  plant: '🪴',
  door: '🚪',
  window: '🪟',
  column: '🏛️',
  reception: '🛎️',
  bar: '🍸',
  wall: '🧱',
};

/* A thin STRIP — a window run the length of a wall, a wall segment — reads
   best as the emoji repeated down its length: 🪟🪟🪟…, one glyph per ~34px,
   like panes. A boxy fixture gets a single glyph. Returns the glyphs to
   print (empty for a type with no emoji, so callers can fall back). */
export function fixtureGlyphs(type, width, height) {
  const e = FIXTURE_EMOJI[type];
  if (!e) return [];
  const long = Math.max(Number(width) || 0, Number(height) || 0);
  const short = Math.min(Number(width) || 0, Number(height) || 0);
  const n = short > 0 && long / short >= 3
    ? Math.max(1, Math.min(40, Math.floor(long / 34)))
    : 1;
  return Array(n).fill(e);
}
